import { cn } from "$/lib/utils/functions/misc.functions";
import { forwardRef, type PropsWithChildren } from "react";
import type { CarouselNavigationButtonProps } from "./CarouselNavigationButton.types";

const CarouselNavigationButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<CarouselNavigationButtonProps>
>(({ selected, carouselType, className, ...props }, forwardedRef) => {
  return (
    <button
      ref={forwardedRef}
      type="button"
      className={cn(
        "ouline-none decoration-none flex m-0 h-1 w-1 cursor-pointer touch-manipulation appearance-none items-center justify-center rounded-full border-0 border-none bg-white p-0 opacity-50 transition-all duration-200",
        {
          "opacity-100": selected,
          "w-3": carouselType === "view-2" && selected,
          "w-full": carouselType === "view-3",
        },
        className,
      )}
      {...props}
    />
  );
});

CarouselNavigationButton.displayName = "CarouselNavigationButton";

export default CarouselNavigationButton;
